// src/landing/components/ServiceSection.js
import React, { useContext, useEffect, useRef } from 'react';
import {
  MessageSquare,
  Sparkles,
  Brain,
  Camera,
  Settings,
  Bell,
} from 'lucide-react';
import '../styles/ServiceSection.css';
import { LanguageContext } from '../../common/contexts/LanguageContext';

// 가운데 휴대폰 한 장
const phoneImg = '/assets/service_phone.png';

// 제목 앞에 붙일 아이콘 6개
const ICONS = [MessageSquare, Sparkles, Brain, Camera, Settings, Bell];

export default function ServiceSection() {
  const { t } = useContext(LanguageContext);

  // JSON에서 features 배열 가져오기
  const features = t('serviceSection.features') || [];

  const cardsRef = useRef([]);

  // 스크롤 등장 애니메이션
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add('show');
        });
      },
      { threshold: 0.3 }
    );
    cardsRef.current.forEach((el) => el && io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <section id="service" className="service-section">
      <h2 className="title">{t('serviceSection.title')}</h2>
      <p className="subtitle">{t('serviceSection.subtitle')}</p>

      <div className="service-grid">
        {/* 왼쪽 3개 카드 */}
        <div className="col">
          {features.slice(0, 3).map((f, i) => {
            const Icon = ICONS[i];
            return (
              <article
                key={i}
                ref={(el) => (cardsRef.current[i] = el)}
                className="service-card"
              >
                <div className="service-card-head">
                  <span className="service-card-icon">
                    <Icon size={30} />
                  </span>
                  <h3>{f.title}</h3>
                </div>
                <p>{f.desc}</p>
              </article>
            );
          })}
        </div>

        {/* 가운데 휴대폰 이미지 */}
        <div className="phone-wrap">
          <div className="phone-frame">
            <img src={phoneImg} alt={t('serviceSection.alt.servicePhone')} />
          </div>
        </div>

        {/* 오른쪽 3개 카드 */}
        <div className="col">
          {features.slice(3).map((f, idx) => {
            const Icon = ICONS[idx + 3];
            return (
              <article
                key={idx + 3}
                ref={(el) => (cardsRef.current[idx + 3] = el)}
                className="service-card"
              >
                <div className="service-card-head">
                  <span className="service-card-icon">
                    <Icon size={30} />
                  </span>
                  <h3>{f.title}</h3>
                </div>
                <p>{f.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
